/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.directive('notifyEditor', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./notify-editor.html'),

      replace: true,

      link(scope, element, attrs) {},

      controller: ['$scope', function ($scope) {}],
    };
  },
]);
